/* eslint-disable no-unused-vars */
import { axiosInstance } from "../servicesSetupMock";
import { getMockOnboarding } from "../recommandation/recommandation.mock";

export const getOnboardingInformation = async (isIndicacao = false) => {
  const { onboarding } = await axiosInstance();
  return getMockOnboarding(onboarding, isIndicacao);
};

export const getEnterprises = async () => {
  const { enterprises } = await axiosInstance();
  return enterprises;
};

export const getPDFExtract = async empreendimentoId => {
  const { extract } = await axiosInstance();
  return extract;
};
